import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { SxProps } from '@mui/material';
import { ReactNode } from 'react';

export interface BasicTableColumn<ColumnType extends string> {
  id: number;
  content: string | JSX.Element;
  field: ColumnType;
  align?: 'left' | 'center' | 'right';
  sx?: SxProps;
}

export interface BasicTableRow {
  id: number;
  dataTestId?: string;
  sx?: SxProps;
}

interface BasicTableProps<
  RowType extends BasicTableRow,
  ColumnType extends BasicTableColumn<keyof RowType & string>,
> {
  rows: RowType[];
  columns: ColumnType[];
  tableSx?: SxProps;
  rowSx?: SxProps;
}

export const BasicTable = <
  RowType extends BasicTableRow,
  ColumnType extends BasicTableColumn<keyof RowType & string>,
>({
  rows,
  columns,
  tableSx,
  rowSx,
}: BasicTableProps<RowType, ColumnType>) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={tableSx}>
        <TableHead>
          <TableRow sx={rowSx}>
            {columns.map((column) => (
              <TableCell key={column.id} align={column.align || 'left'} sx={column.sx || null}>
                {column.content}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} sx={row.sx || null} data-testid={row.dataTestId}>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align || 'left'} sx={column.sx}>
                  {row[column.field] as ReactNode}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
